// 進行異步執行
import { apiInformation } from '@/resource'

export default {
  async actionGetInformation({ commit, state }) {
    try {
      const result = await apiInformation()
      if (result.data.domainWebSite) {
        commit('setDomainWebSite', result.data.domainWebSite)
        commit('setDomainWebSiteCn', result.data.domainWebSiteCn)
        commit('setDomainWebSiteIr', result.data.domainWebSiteIr)
        commit('setContactEmail', result.data.contactEmail)
        commit('setAccountEmail', result.data.accountEmail)
      } else {
        console.log('error')
      }
    } catch (error) {
      console.error('Failed to get information:', error)
    }
  },
}
